/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Twda_Reason_No_PlaceInputs */



/**
* | output |
* | --- |
* | "the event has no country and is not marked online — set one to submit" |
*
* @param {Twda_Reason_No_PlaceInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_reason_no_place = /** @type {((inputs?: Twda_Reason_No_PlaceInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Reason_No_PlaceInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("l'événement n'a ni pays ni mention en ligne — renseignez-en un pour soumettre")
	if (locale === "es") return /** @type {LocalizedString} */ ("el evento no tiene país ni está marcado como en línea — indica uno para enviarlo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("o evento não tem país nem está marcado como online — defina um para enviar")
	if (locale === "it") return /** @type {LocalizedString} */ ("l'evento non ha un paese né è segnato come online — impostane uno per inviarlo")
	return /** @type {LocalizedString} */ ("the event has no country and is not marked online — set one to submit")
});